var X = require("./x");

var hasTransitions = X.supportsCSSProperty("transition");

/**
 * Info-Tooltip
 */
var Info = module.exports = function(trigger, content, opts) {
  var wrapper = document.createElement("div");
  var tip = document.createElement("div");
  var arr = document.createElement("div");
  var fadeTimeout = 0;

  wrapper.className = opts.wrapperClassName;
  wrapper.appendChild(tip);
  wrapper.appendChild(arr);
  wrapper.style.display = "none";
  X.body.appendChild(wrapper);
  arr.className = opts.arrowClassName;
  tip.className = opts.className;
  tip.innerHTML = content;

  // add mouse listeners
  X.addEventListener(trigger, "mouseover", function(ev) {
    wrapper.style.display = "block";
    var rect = trigger.getBoundingClientRect();
    var pos = X.scrollPosition();
    var windowWidth = window.innerWidth;

    var left = (pos.x + rect.left + (rect.right - rect.left) / 2);
    var top = (pos.y + rect.top);
    var arrWidth = X.offsetWidth(arr);
    var arrHeight= X.offsetHeight(arr);
    var width = X.offsetWidth(tip);
    var height = X.offsetHeight(tip);
    var shiftRatio = (left - arrWidth / 2 + opts.offsetX) / windowWidth;

    // position arrow
    arr.style.left = (left - arrWidth / 2) + "px";
    arr.style.top = (top - arrHeight) + "px";

    // position tooltip
    tip.style.left = (left - arrWidth / 2 - shiftRatio * width + opts.offsetX)
        + "px";
    tip.style.top = (top - arrHeight + opts.offsetY - height) + "px";

    clearTimeout(fadeTimeout);
    fadeTimeout = setTimeout(function() {
      // defer so display="block" is applied first and thus the transition is
      // triggered correctly. Thanks to browser optimizations ;)
      wrapper.className = opts.wrapperClassName + " active";
    }, 0);
  });

  X.addEventListener(trigger, "mouseout", function(ev) {
    clearTimeout(fadeTimeout);
    wrapper.className = opts.wrapperClassName;
    fadeTimeout = setTimeout(function() {
      wrapper.style.display = "none";
    }, hasTransitions ? 300 : 0);
  });
}
